// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__20XM9","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3hbag","obliqueLine":"membershipbadge_obliqueLine__3KIyr"};